import React, { useEffect } from 'react';
import './delete.css';

function Popup({ deleteData , para, ID}) {

    return (
        <div className="modal fade" id={ID ? ID: `logout`} tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-position">
                <div className="modal-content border-none">
                    <div className="row">
                        <div className="col-md-12 float-start text-center p-5">
                            <img className="mb-3 text-center align-items-center" src="/Images/question-mark.svg" alt="alert" />
                            <label className="w-100 bold-text font-14 text-center mb-3">{ para ? para : `Are you sure you want to Delete?`}</label>
                            <div className="col-md-12 float-start text-center">
                                <button type="button" className="btn hive-btn-error" data-bs-dismiss="modal">
                                    No
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        deleteData();
                                    }}
                                    className="btn hive-btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Yes
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Popup;
